import {
  Card,
  CardInfo,
  Cards,
  Chapter,
  CourseChapter,
  CourseModuleCards,
  GenerativeAiChapters,
  ManualChapter,
} from "@mikros/library";
import { Alert, Confirm, GenerateCourseChaptersCards } from "@mikros/shared-ui";
import { Button } from "@progress/kendo-react-buttons";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import {
  Sortable,
  SortableItemUIProps,
  SortableOnDragOverEvent,
  SortableOnNavigateEvent,
} from "@progress/kendo-react-sortable";
import { PdfChapters } from "./pdfChapters";
import ApiServices from "../../../service/apiService";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Loading } from "../../common/loading";
import toast from "react-hot-toast";
import Spinner from "../../../utils/Loader";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import { Error } from "@progress/kendo-react-labels";

export interface PdfTempChptsAiProps {
  chapterData: GenerativeAiChapters;
  duplicateS3File: (
    sourceKey: string,
    destinationKey: string,
    fileType: string
  ) => void;
  handleUploadGiveUrl: (e: CourseModuleCards) => void;
  handleUpdateStatusRev: (
    status: string,
    course: CourseModuleCards
  ) => Promise<boolean>;
  handleUpdateStatusAll: (
    status: string,
    course?: CourseModuleCards
  ) => Promise<boolean>;
  handleVideoGeneration?: (e: any) => Promise<string | false>;
  handleImageGeneration?: (e: any) => Promise<string | false>;
  // handleAudioGeneration?:(e:any)=>Promise<string|false>;
  handleAudioGeneration?: (e: any) => Promise<{ presignedUrl: string; prompt: string } | false>;
}

export function PdfTempChpts(props: PdfTempChptsAiProps) {
  console.log("chapter data pdf temp chpt", props.chapterData);

  const intl = useIntl();
  const navigate = useNavigate();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();

  const spinner = new Spinner();
  const [courseName, setCourseName] = useState<string>(
    props.chapterData.data.courseName
  );
  const [chapterData, setChapterData] = useState<GenerativeAiChapters>(
    props.chapterData
  );
  const [chapterCards, setChapterCards] = useState<CourseModuleCards>({
    chapters: [
      {
        cards: [{ cardInfo: { card: [{} as Card] } as CardInfo } as Cards],
      } as CourseChapter,
    ],
  } as CourseModuleCards);
  const [chptDragData, setChptDragData] = useState<Array<object>>(
    props.chapterData.data.Chapters!!
  );
  const [nextScreen, setNextScreen] = useState<boolean>(false);
  const [getChptFailed, setGetChptFailed] = useState<boolean>(false);

  const [requestingChaptersList, setRequestingChaptersList] = useState<
    string[]
  >(
    props?.chapterData?.data?.Chapters?.map((chapterData: any) => {
      return chapterData.chapterId;
    })
  );
  const [enableDrag, setEnableDrag] = useState<boolean>(false);
  const [pdfGenerateCardDialog, setPdfGenerateCardDialog] =
    useState<boolean>(false);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [errors, setErrors] = useState<any>({});

  const handleListOfRequestingChapterCards = (chapterId: string) => {
    setErrors((prev: any) => ({
      ...prev,
      noChapter: null, //clear the error
    }));
    console.log("entering handleListOfRequestingChapterCards");
    if (requestingChaptersList.includes(chapterId)) {
      let chptList = requestingChaptersList;
      chptList = chptList.filter((ele) => {
        return ele !== chapterId;
      });
      setRequestingChaptersList(chptList);
    } else {
      let chptList = requestingChaptersList;
      chptList.push(chapterId);
      setRequestingChaptersList(chptList);
    }
  };

  const onDragOver = (event: SortableOnDragOverEvent) => {
    console.log("This is drag over", event.newState);
    let data = chapterData;
    data.data.Chapters = event.newState as Chapter[];
    setChptDragData(data.data.Chapters);
    setChapterData(data);
  };

  const onNavigate = (event: SortableOnNavigateEvent) => {
    console.log("This is navigate", event.newState);
    let data = chapterData;
    data.data.Chapters = event.newState as Chapter[];
    setChptDragData(data.data.Chapters);
    setChapterData(data);
  };

  const invokeChapterCards = async () => {
    console.log("requesting list of chapter", requestingChaptersList);
    const chapters = chapterData.data.Chapters.filter((chapter: any) => {
      if (requestingChaptersList.includes(chapter.chapterId)) {
        return chapter;
      }
    });

    const data = {
      reportInfo: {
        fileId: chapterData.fileId,
        courseAndChpt: {
          courseName: courseName,
          Chapters: chapters,
        },
      },
    };

    const api = ApiServices.getInstance();

    if (accountInstance.accntId) {
      await api
        .makeRequestWithoutSpinner(
          `${accountInstance.accntId}/course/${chapterData.courseId}/pdfGenAiCourse/pdfGenAiCards`,
          "POST",
          data
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            console.log("In entered in error message");
            console.log("res status sgfred", res.status);
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
        })
        .catch((e) => console.log("This is the error"));
    }
    navigate("/courses");
  };

  const getChapterCards = async () => {
    console.log("requesting list of chapter", requestingChaptersList);
    const chapters = chapterData.data.Chapters.filter((chapter: any) => {
      if (requestingChaptersList.includes(chapter.chapterId)) {
        return chapter;
      }
    });

    const data = {
      reportInfo: {
        fileId: chapterData.fileId,
        courseAndChpt: {
          courseName: courseName,
          Chapters: chapters,
        },
      },
    };

    const api = ApiServices.getInstance();
    toast.custom(<Loading />, { duration: Infinity });

    if (accountInstance.accntId) {
      await api
        .makeRequestWithoutSpinner(
          `${accountInstance.accntId}/course/${chapterData.courseId}/pdfGenAiCourse/pdfGenAiCards`,
          "POST",
          data
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            console.log("In entered in error message");
            console.log("res status sgfred", res.status);
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          spinner.showSpinner();
        })
        .catch((e) => console.log("This is the error"));
    }
    // spinner.hideSpinner();
    await pullChapterCards();
  };

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleEnableDrag = (e: boolean) => {
    setEnableDrag(e);
  };

  // const toggleGenerateCardDialog = () => {
  //   setPdfGenerateCardDialog(!pdfGenerateCardDialog);
  // };

  const toggleGenerateCardDialog = () => {
    console.log("inside toggle generate card dialog");

    if (requestingChaptersList.length < 1) {
      console.log("inside request chapter list less than 1");
      let err: any = {};
      err.noChapter = {
        error: intl.formatMessage({ id: "courses.generateChapters.error" }),
      };
      setErrors(err);
    } else {
      setPdfGenerateCardDialog(!pdfGenerateCardDialog);
    }
  };

  const pullChapterCards = async () => {
    let data = {
      courseId: chapterData.courseId,
      // accntId: "f9afa76e-04d1-48dc-b5c8-69471c5f3de5",
      accntId: accountInstance.accntId,
      chapterCount: requestingChaptersList.length,
    };
    setIsLoading(true);

    let flag = true;
    const api = ApiServices.getInstance();
    let maxMiliSeconds = 0;
    while (flag) {
      if (accountInstance.accntId) {
        await api
          .makeRequestWithoutSpinner(
            `${accountInstance.accntId}/course/${data.courseId}/pdfGenAiCourse/pdfGenAiCards/pullPdfCards`,
            "POST",
            data
          )
          .then(async (res) => {
            if (res && res.errorMessage) {
              console.log("In entered in error message");
              console.log("res status sgfred", res.status);
              setErrorFlag(true);
              await errorInstance.updateErrorCode(res.errorMessage);
              return;
            }
            const dt = typeof res === "string" ? true : false;

            if (dt) {
              if (maxMiliSeconds <= 240000) {
                await sleep(5000);
                maxMiliSeconds = maxMiliSeconds + 5000;
              } else {
                flag = false;
                setIsLoading(false);
                spinner.hideSpinner();
              }
            } else {
              console.log("Going to hide spinner");
              toast.remove();
              spinner.hideSpinner();
              flag = false;
              setChapterCards(res);
              setNextScreen(true);
              setIsLoading(false);
            }
          })
          .catch((err) => {
            console.log(err.message);
            toast.remove();
          });
      }
    }
  };

  function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const updateTheCourse = async (
    course: CourseModuleCards
  ): Promise<boolean> => {
    let chapters: ManualChapter[] = [];
    for (let courseChapter of course.chapters) {
      let updateChapter = {
        chapterName: courseChapter.chapterName,
        courseId: courseChapter.courseId,
        createdBy: courseChapter.createdBy,
        date: courseChapter.date,
        chapterId: courseChapter.chapterId,
        description: courseChapter.description,
        publishedBy: "",
        publishedDate: courseChapter.date,
        seqNo: courseChapter.seqNo,
        updatedBy: "",
        reviewedBy: "",
        reviewedDate: "",
        cards: courseChapter.cards,
        isLastChapter: courseChapter.isLastChapter,
      };

      for (let card of updateChapter.cards) {
        // @ts-ignore
        delete card.entityId;
        // @ts-ignore
        delete card.status;
        // @ts-ignore
        delete card.createdAt;
        // @ts-ignore
        delete card.date;
        // @ts-ignore
        delete card.chapterName;
        // @ts-ignore
        delete card.entryType;
        // @ts-ignore
        delete card.recType;
        // @ts-ignore
        delete card.updatedAt;
      }

      chapters.push(updateChapter);
    }

    const courseBody = {
      courseId: course.courseId,
      chapters: chapters,
    };

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      return await api
        .makeRequest(
          `${accountInstance.accntId}/course/${course.courseId}`,
          "PUT",
          courseBody
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return false;
          }
          // navigate("/courses")
          return true;
        })
        .catch((error) => {
          return false;
        });
    } else {
      return false;
    }
  };

  return (
    <div className="w-full h-full flex flex-col space-y-5">
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              navigate("/courses");
            }}
          />
        </Dialog>
      )}
      {pdfGenerateCardDialog && (
        <Dialog className="alertDialogue">
          <Confirm
            description={`${intl.formatMessage({
              id: "generateChapters.chapterGenMessage",
            })}`}
            successText={`${intl.formatMessage({
              id: "chapter.success",
            })}`}
            failureText={`${intl.formatMessage({
              id: "chapter.failure",
            })}`}
            cancelText={`${intl.formatMessage({
              id: "cancelButton",
            })}`}
            icon={"alertShape.png"}
            iconMsg={`${intl.formatMessage({
              id: "iconMsgAlert",
            })}`}
            backgroundColor={"mk-orange"}
            onSuccess={() => {
              toggleGenerateCardDialog();
              invokeChapterCards();
            }}
            onFailure={() => {
              toggleGenerateCardDialog();
              getChapterCards();
            }}
          />
        </Dialog>
      )}

      {getChptFailed && (
        <Dialog className="pdfUpload">
          <div className="flex flex-col justify-center space-y-3 items-center">
            <div className="flex justify-center items-center font-bold text-sm">
              {/* Check whether the selected chapters are valid and present in the
              pdf and retry. */}
              <FormattedMessage id="pdfTempChpts.checkValidChpts"></FormattedMessage>
            </div>
            <Button
              themeColor={"error"}
              onClick={() => {
                setGetChptFailed(false);
              }}
            >
              <FormattedMessage id="users.buttonText.Ok"></FormattedMessage>
            </Button>
          </div>
        </Dialog>
      )}
      {nextScreen ? (
        <GenerateCourseChaptersCards
          isManual={false}
          duplicateS3File={(
            sourceKey: string,
            destinationKey: string,
            fileType: string
          ) => {
            return props.duplicateS3File(sourceKey, destinationKey, fileType);
          }}
          specificCreateCourseFunction={(
            course: CourseModuleCards
          ): Promise<boolean> => {
            return updateTheCourse(course);
          }}
          cards={chapterCards}
          handleUploadGiveUrl={(e: CourseModuleCards) => {
            return props.handleUploadGiveUrl(e);
          }}
          tenantRole={accountInstance.accntRole}
          handleUpdateStatusRev={(
            status: string,
            course: CourseModuleCards
          ): Promise<boolean> => {
            return props.handleUpdateStatusRev(status, course);
          }}
          handleUpdateStatusAll={(
            status: string,
            course: CourseModuleCards
          ): Promise<boolean> => {
            return props.handleUpdateStatusAll(status, course);
          }}
          handleVideoGeneration={(e: any) => {
            console.log("calling handle video generation", e);
            if (props.handleVideoGeneration) {
              return props.handleVideoGeneration(e);
            }
            return Promise.resolve(false);
          }}
          handleImageGeneration={(e: any) => {
            console.log("calling handle image generation", e);
            if (props.handleImageGeneration) {
              return props.handleImageGeneration(e);
            }
            return Promise.resolve(false);
          }}
          // handleAudioGeneration={(e: any) => {
          //   console.log("calling handle audio generation", e);
          //   if (props.handleAudioGeneration) {
          //     return props.handleAudioGeneration(e);
          //   }
          //   return Promise.resolve(false);
          // }}
          handleAudioGeneration={(e: any): Promise<{ presignedUrl: string; prompt: string } | false> => {
            console.log("Calling handle audio generation ", e);
            if (props.handleAudioGeneration) {
              return props.handleAudioGeneration(e);
            }
            return Promise.resolve(false);
          }}


        />
      ) : (
        <>
          <div>
            {errors.noChapter?.error && <Error>{errors.noChapter.error}</Error>}
          </div>
          <Sortable
            className="flex flex-col w-full"
            idField={"chapterId"}
            disabledField={"disabled"}
            data={chptDragData}
            itemUI={(e: SortableItemUIProps) => {
              let props: any = {
                ...e,
                handleChecked(chapterId: string) {
                  handleListOfRequestingChapterCards(chapterId);
                },
                reqListChapters: requestingChaptersList,
                enableDrag: enableDrag,
                handleEnableDrag(enableDisable: boolean) {
                  handleEnableDrag(enableDisable);
                },
              };
              return PdfChapters(props);
            }}
            onNavigate={onNavigate}
            onDragOver={onDragOver}
          />
          <div className={` w-full flex justify-end items-center`}>
            <Button
              themeColor="primary"
              onClick={async () => {
                // await getChapterCards();
                toggleGenerateCardDialog();
              }}
            >
              <FormattedMessage id="generateCardsButton" />
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
